import { useMemo } from 'react'
import { useReactiveVar } from '@apollo/client'
import { PageTemplate, Tabs } from '@npco/zeller-design-system'

import { rvSiteDetails } from 'graphql/reactiveVariables'
import { getIsMobileDevice } from 'utils/device'

import { useSiteTabs } from '../hooks/useSiteTabs'

export const SiteNavigation = () => {
  const { tabs, currentTab, areTabsVisible } = useSiteTabs()
  const siteDetails = useReactiveVar(rvSiteDetails)
  const terminals =
    siteDetails?.devices?.filter(
      (device) => !getIsMobileDevice(device.model)
    ) ?? []

  const visibleTabs = useMemo(
    () =>
      terminals.length > 0
        ? tabs
        : tabs.filter((tab) => tab.children !== 'Appearance'),
    [tabs, terminals.length]
  )

  if (!areTabsVisible) {
    return null
  }

  return (
    <PageTemplate.HeaderSecondaryRow data-testid="site-navigation">
      <Tabs currentTab={currentTab}>
        {visibleTabs.map((tab) => (
          <Tabs.Item key={tab.value} {...tab} />
        ))}
      </Tabs>
    </PageTemplate.HeaderSecondaryRow>
  )
}
